import { jsxs as s, jsx as a } from "react/jsx-runtime";
import { m as n } from "motion/react";
import o from "./play-button-indicator.module.less.js";
const p = ({ className: t, animation: r }) => /* @__PURE__ */ s(n.div, { ...r, className: [o.playButtonWrapper, t ?? ""].join(" "), children: [
  /* @__PURE__ */ a("div", { className: o.playButtonBackground }),
  /* @__PURE__ */ a("span", { className: [o.icon, "ui-icon-play"].join(" ") })
] });
export {
  p as PlayButtonIndicator,
  p as default
};
